module.exports = __webpack_public_path__ + "img/comercial.dda0d198.png";